import React, {useEffect, useRef, useState} from "react";
import Container from "@mui/material/Container";
import {Head, Loading} from "../../components";
import {Box, Tooltip} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import ReactPaginate from "react-paginate";
import IconButton from "@mui/material/IconButton";
import SyncIcon from "@mui/icons-material/Sync";
import moment from "moment-jalaali";
import {useSelector} from "react-redux";
import Api from "../../utils/api";
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import queryString from 'query-string';
import Divider from "@mui/material/Divider";
import DialogActions from "@mui/material/DialogActions";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import {toast} from "react-toastify";
import SunEditor, {buttonList} from "suneditor-react";
import Chip from "@mui/material/Chip";

const ContractTemplate = () => {

    const history = useNavigate();
    const location = useLocation();

    const contractVariables = useSelector((state) => state.authReducer.setting.contract_variables)

    const query = queryString.parse(location.search);
    const [params, setParams] = useState({
        page: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 100,
        status: query.status ? parseInt(query.status) : 0,
        parent_id: query.parent_id ? parseInt(query.parent_id) : '',
        name: query.name ? query.name : '',
        username: query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
    });
    const [loading, setLoading] = useState(true);
    const [contract, setContract] = useState([]);
    const [ShowImg, setShowImg] = useState(false);
    const [img, setImg] = useState('')
    const [open, setOpen] = React.useState(false);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [searchTime, setSearchTime] = useState("");
    const [form, setForm] = useState({})
    const [body, setBody] = useState("")
    const [count, setCount] = useState(1)

    const editor = useRef();

    // The sunEditor parameter will be set to the core suneditor instance when this function is called
    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setOpenEdit(false);
    };

    const handleClickOpenEdit = () => {
        setOpenEdit(true);
    };


    const handleContract = () => {
        setLoading(true)
        new Api().get('/contract_template', {}).then((response) => {
            if (typeof response !== "undefined") {
                setContract(response);
            }

            setLoading(false);
        })
    }

    useEffect(() => {
        handleContract()
    }, [])

    useEffect(() => {


        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        }, 500);

    }, []);


    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = value;
                break;
        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;

        history(`/contract/${url}`);

    };


    const handleSubmit = (event) => {
        event.preventDefault();

        let obj = {
            "form": "contract_template_store",
            ...form
        }

        setLoading(true);

        new Api().post(`/contract_template`, obj, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    setOpen(false)
                    handleContract()
                } else {
                    toast.error(response.msg);
                }
            }
            setOpen(false)
            setLoading(false);
        })

    }


    const handleEditValue = (item) => {
        form["desc"] = item.desc
        form["body"] = item.body
        form["id"] = item.id

    }


    const handleEdit = (event) => {

        event.preventDefault();

        let obj = {
            "form": "contract_template_update",
            "title": form.title,
            "status": form.status,
            "id": form["id"],
            ...form
        }

        setLoading(true);
        new Api().put(`/contract_template`, obj, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    handleContract()
                    setOpenEdit(false)

                } else {
                    toast.error(response.msg);
                }
            }
            setOpen(false)
            setLoading(false);
        })
    }


    const handleChangeElement = (event) => {

        let frm = form;
        frm[event.target.name] = event.target.value;
        setForm({...frm});

    };
    const handleAddChip = (item ) => {
        let regex = /_[0-9]_+/g;
        let result = form["body"]?.match(regex);
        let x = `_${result?.length + 1 || 1}_`
        setBody(x)
        let arr = {...form};
        arr["variables"] = ({...form["variables"] , [x || "_1_"]: item[0]})
        form["variables"] = arr["variables"]
    };

    const handleForm = (value) => {
        let frm = form;

        frm['body'] = value;

        setForm({...frm});
    };

    const pageCount = Math.ceil(parseInt(contract?.details?.list?.total) / parseInt(contract?.details?.list?.per_page));

    return (
        <Container>
            <Head data={{'link': '/', 'title': ' قرارداد  بازاریاب ها', 'description': ''}}/>

            <Box mb={2}>
                <Grid container alignItems="center">
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem value="10">10</MenuItem>
                            <MenuItem value="20">20</MenuItem>
                            <MenuItem value="30">30</MenuItem>
                            <MenuItem value="50">50</MenuItem>
                            <MenuItem value="100">100</MenuItem>
                            <MenuItem value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>

                <Tooltip title="افزودن" onClick={() => handleClickOpen()}>
                    <IconButton>
                        <ControlPointIcon/>
                    </IconButton>
                </Tooltip>

                <Tooltip title="سینک" onClick={() => handleContract()}>
                    <IconButton>
                        <SyncIcon/>
                    </IconButton>
                </Tooltip>


            </div>

            <Dialog
                open={open || openEdit}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <form onSubmit={openEdit ? handleEdit : handleSubmit} className='animate__animated animate__fadeIn'
                      encType="multipart/form-data">
                    <DialogTitle id="alert-dialog-title">ایجاد قرارداد جدید</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Divider/>
                            <Grid item xs={12}>
                                <div style={{margin: "30px 0 10px 0"}}>عنوان</div>
                                <TextField
                                    style={{textAlign: 'left', direction: 'ltr'}}
                                    label="عنوان"
                                    value={form["title"]}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='title'
                                    onChange={(e) => {
                                        let frm = form;
                                        frm['title'] = e.target.value;
                                        setForm({...frm});
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                </TextField>
                                <div style={{margin: "30px 0 10px 0"}}>متن کوتاه</div>
                                <SunEditor
                                    setOptions={{
                                        height: 200,
                                        buttonList: buttonList.complex
                                    }}
                                    value={form["desc"]}
                                    height="100px"
                                    getSunEditorInstance={getSunEditorInstance}
                                    defaultValue={form["desc"]}
                                    onChange={(value) => {
                                        let frm = form;
                                        frm['desc'] = value;
                                        setForm({...frm});
                                    }}/>
                                <div/>
                                {Object.entries(contractVariables)?.map((item, index) => {
                                    return (
                                        <Chip
                                            label={item[1]}
                                            clickable
                                            color="default"
                                            onClick={() => handleAddChip(item , form["body"])}
                                        />
                                    )
                                })}
                                <SunEditor
                                    appendContents={body}
                                    setOptions={{
                                        height: 200,
                                        buttonList: buttonList.complex
                                    }}
                                    value={form["body"]}
                                    height="500px"
                                    getSunEditorInstance={getSunEditorInstance}
                                    defaultValue={form["body"]}
                                    onChange={(value) => {
                                        handleForm(value)
                                    }}/>
                                <div/>
                            </Grid>
                            <Divider/>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            بستن
                        </Button>
                        <Button disabled={loading} type={'submit'} color="primary" autoFocus>
                            ارسال اطلاعات
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <div style={{overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>آی دی بازاریابی</th>
                        <th>کد بازاریابی</th>
                        <th>عنوان</th>
                        <th>خلاصه متن</th>
                        <th>تاریخ ایجاد</th>
                        <th>وضعیت</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {contract?.contract_templates?.data?.map((item, index) => {
                        return (
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item.marketer_id || "---"}</td>
                                <td>{item.marketer?.marketer_code || "---"}</td>
                                <td>{item.title || "---"}</td>
                                <td>{item.desc || "---"}</td>
                                <td style={{direction: 'ltr'}}>{moment(item.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td style={{direction: 'ltr'}}>
                                    <Tooltip title="وضعیت">
                                        <Chip size={"small"} variant={"outlined"}
                                              color={+item.status === 1 ? "primary" : "secondary"}
                                              label={+item.status === 1 ? 'فعال' : 'غیرفعال'} clickable={true}
                                              onClick={(event) => {
                                                  handleEditValue(item)
                                                  form["status"] = +item.status === 1 ? 0 : 1
                                                  handleEdit(event)
                                              }}/>
                                    </Tooltip>
                                </td>
                                <td>
                                    <Button onClick={() => {
                                        handleEditValue(item)
                                        handleClickOpenEdit()
                                    }} size={"small"} color={"secondary"} variant={"outlined"}>ویرایش</Button>&nbsp;
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
            <Dialog
                open={ShowImg}
                onClose={() => setShowImg(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <img style={{borderRadius: 0, maxHeight: 300}} src={img}/>
            </Dialog>
        </Container>
    );

}

export default ContractTemplate;